import { render } from "./CompanyDetailView.vue?vue&type=template&id=6d4199e7&scoped=true"
import script from "./CompanyDetailView.vue?vue&type=script&lang=js"
export * from "./CompanyDetailView.vue?vue&type=script&lang=js"

import "./CompanyDetailView.vue?vue&type=style&index=0&id=6d4199e7&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4199e7"]])

export default __exports__